import { ToggleGroupCard, ToggleGroupCardItem } from '@/components/ui/toggle-group';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { DisruptionNotificationEnum, DisruptionNotificationGracePeriodEnum } from 'src/graphql/schema';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectLabel,
} from '@/components/ui/select';

type Props = {
  description: string;
  values: {
    disruptionNotification: DisruptionNotificationEnum;
    disruptionNotificationGracePeriod: DisruptionNotificationGracePeriodEnum | null;
  };
  options: {
    disruptionNotificationOptions: {
      value: DisruptionNotificationEnum;
      icon: React.ElementType;
      label: string;
    }[];
    gracePeriodOptions: {
      value: DisruptionNotificationGracePeriodEnum;
      label: string;
    }[];
  };
  onDisruptionNotificationChange: (value: DisruptionNotificationEnum) => void;
  onDisruptionNotificationGracePeriodChange: (value: DisruptionNotificationGracePeriodEnum) => void;
  graceNote?: string;
  graceLabel?: string;
};

const DisruptedAccessNotifications = ({
  description,
  values,
  options,
  onDisruptionNotificationChange,
  onDisruptionNotificationGracePeriodChange,
  graceNote,
  graceLabel = 'Grace period',
}: Props) => {
  const { disruptionNotification, disruptionNotificationGracePeriod } = values;
  const { disruptionNotificationOptions, gracePeriodOptions } = options;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Disrupted access notifications</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <ToggleGroupCard
          type="single"
          className="flex-col w-full"
          onValueChange={onDisruptionNotificationChange}
          value={values.disruptionNotification}
        >
          {disruptionNotificationOptions.map(({ value, icon: Icon, label }) => (
            <ToggleGroupCardItem key={value} value={value} icon={Icon} title={label} />
          ))}
        </ToggleGroupCard>

        {disruptionNotification === DisruptionNotificationEnum.SendNotification && (
          <div className="space-y-2">
            <div className="text-sm font-semibold text-foreground">{graceLabel}</div>
            <Select
              value={disruptionNotificationGracePeriod ?? ''}
              onValueChange={onDisruptionNotificationGracePeriodChange}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select grace period" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>{graceLabel}</SelectLabel>
                  {gracePeriodOptions.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
            {graceNote && <p className="text-sm text-muted-foreground">{graceNote}</p>}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default DisruptedAccessNotifications;
